<template>
  <div class="button" @click="renew">Renew Subscription</div>
</template>

<script>
import axios from 'axios'
// import { mapActions } from 'vuex'
import alert from '@/lib/alert'

export default {
  name: 'RenewButton',
  methods: {
    // ...mapActions('alerts', ['setError', 'setWarning']),
    renew() {
      axios({
        method: 'post',
        url: `${process.env.VUE_APP_SERVER_URL}renewSubscription`,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token'),
        },
      }).then(() => {
        this.$emit('reload');
      }).catch(err => {
        console.log(err);
        // this.setError(err);
        alert.showError(err);
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.button {
  width: 13rem;
  height: 2.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ebc659;
  color: white;
  border-radius: 0.2rem;
  transition: 0.3rem;

  &:hover {
    cursor: pointer;
    background-color: #e6b82e;
  }
}
</style>